import AdministrationView from '@v2/domains/administration/views/Administration.view'
import CreateEmailTemplateView from '@v2/domains/email-template/views/CreateEmailTemplate/CreateEmailTemplate.view'
import EmailTemplateView from '@v2/domains/email-template/views/EmailTemplate/EmailTemplate.view'
import EmailTemplatesView from '@v2/domains/email-template/views/EmailTemplates/EmailTemplates.view'
import PoliciesView from '@v2/domains/policy/views/Policies.view'
import RoleView from '@v2/domains/role/views/Role.view'
import RolesView from '@v2/domains/role/views/Roles.view'
import TagsView from '@v2/domains/tag/views/Tags.view'
import CreateUserView from '@v2/domains/user/views/CreateUser.view'
import SingleUserView from '@v2/domains/user/views/SingleUser.view'
import UsersView from '@v2/domains/user/views/Users.view'
import { createElement } from 'react'

import AccountsPage from 'src/benestream/pages/Accounts/AccountsPage'
import SingleAccountPage from 'src/benestream/pages/Accounts/SingleAccountPage'
import DataLoaderPage from 'src/benestream/pages/DataLoader/DataLoaderPage'
import CreateLeadPage from 'src/benestream/pages/Leads/CreateLeadPage'
import LeadsPage from 'src/benestream/pages/Leads/LeadsPage'
import SingleLeadPage from 'src/benestream/pages/Leads/SingleLeadPage'
import SearchResultPage from 'src/benestream/pages/Search/SearchResultPage'
import SettingsPage from 'src/benestream/pages/Settings/SettingsPage'

import { RouteConfig } from '../types/routing.types'
import { BENESTREAM_ROUTES_CONFIG } from './route-configs.constants'

export const BENESTREAM_ROUTES: Record<string, RouteConfig> = {
  LEADS: {
    ...BENESTREAM_ROUTES_CONFIG.LEADS,
    element: createElement(LeadsPage),
  },
  LEAD_DETAIL: {
    ...BENESTREAM_ROUTES_CONFIG.LEAD_DETAIL,
    element: createElement(SingleLeadPage),
  },
  LEAD_CREATE: {
    ...BENESTREAM_ROUTES_CONFIG.LEAD_CREATE,

    element: createElement(CreateLeadPage),
  },
  ACCOUNTS: {
    ...BENESTREAM_ROUTES_CONFIG.ACCOUNTS,
    element: createElement(AccountsPage),
  },
  ACCOUNT_DETAIL: {
    ...BENESTREAM_ROUTES_CONFIG.ACCOUNT_DETAIL,
    element: createElement(SingleAccountPage),
  },
  ADMINISTRATION: {
    ...BENESTREAM_ROUTES_CONFIG.ADMINISTRATION,
    element: createElement(AdministrationView),
  },
  SETTINGS: {
    ...BENESTREAM_ROUTES_CONFIG.SETTINGS,
    element: createElement(SettingsPage),
  },
  DATA_LOADER: {
    ...BENESTREAM_ROUTES_CONFIG.DATA_LOADER,
    element: createElement(DataLoaderPage),
  },
  SEARCH: {
    ...BENESTREAM_ROUTES_CONFIG.SEARCH,
    element: createElement(SearchResultPage),
  },
  ADMINISTRATION_POLICIES: {
    ...BENESTREAM_ROUTES_CONFIG.ADMINISTRATION_POLICIES,
    element: createElement(PoliciesView),
  },
  ADMINISTRATION_ROLES: {
    ...BENESTREAM_ROUTES_CONFIG.ADMINISTRATION_ROLES,
    element: createElement(RolesView),
  },
  ADMINISTRATION_ROLES_DETAIL: {
    ...BENESTREAM_ROUTES_CONFIG.ADMINISTRATION_ROLES_DETAIL,
    element: createElement(RoleView),
  },
  ADMINISTRATION_TAGS: {
    ...BENESTREAM_ROUTES_CONFIG.ADMINISTRATION_TAGS,
    element: createElement(TagsView),
  },
  ADMINISTRATION_USERS: {
    ...BENESTREAM_ROUTES_CONFIG.ADMINISTRATION_USERS,
    element: createElement(UsersView),
  },
  ADMINISTRATION_USERS_CREATE: {
    ...BENESTREAM_ROUTES_CONFIG.ADMINISTRATION_USERS_CREATE,
    element: createElement(CreateUserView),
  },
  ADMINISTRATION_USERS_DETAILS: {
    ...BENESTREAM_ROUTES_CONFIG.ADMINISTRATION_USERS_DETAILS,
    element: createElement(SingleUserView),
  },
  ADMINISTRATION_EMAIL_TEMPLATE: {
    ...BENESTREAM_ROUTES_CONFIG.ADMINISTRATION_EMAIL_TEMPLATE,
    element: createElement(EmailTemplatesView),
  },
  ADMINISTRATION_EMAIL_TEMPLATE_DETAIL: {
    ...BENESTREAM_ROUTES_CONFIG.ADMINISTRATION_EMAIL_TEMPLATE_DETAIL,
    element: createElement(EmailTemplateView),
  },
  ADMINISTRATION_EMAIL_TEMPLATE_CREATE: {
    ...BENESTREAM_ROUTES_CONFIG.ADMINISTRATION_EMAIL_TEMPLATE_CREATE,
    element: createElement(CreateEmailTemplateView),
  },
}
